import React from "react";
import Chapter from "@/components/landing/Chapter";
import Reveal from "@/components/landing/Reveal";
import PhotoFrame from "@/components/landing/PhotoFrame";
import { IMAGES } from "@/lib/landingConfig";
import { useLandingImages } from "@/lib/ImagesContext";

const Speakers = () => {
  const { bySlot } = useLandingImages();
  const speakers = [
    {
      name: "Lula Ballarino",
      topic: "El arte de relacionarte y multiplicar tu impacto.",
      image: bySlot["speaker-lula"] || IMAGES.speakerLula,
      placeholder: "Lula Ballarino",
      online: true,
    },
    {
      name: "Francisca Molina",
      topic: "Claves para una gestión empresarial eficiente.",
      image: bySlot["speaker-francisca"] || IMAGES.speakerFrancisca,
      placeholder: "Francisca Molina",
    },
    {
      name: "Karla Ramírez Rey",
      topic: "La arquitectura invisible del éxito.",
      image: bySlot["speaker-karla"] || IMAGES.speakerKarla,
      placeholder: "Karla Ramírez Rey",
    },
    {
      name: "Verónica Chumillas",
      topic: "Tu voz también se ve — presencia, seguridad y claridad ante la cámara.",
      image: bySlot["speaker-veronica"] || IMAGES.speakerVeronica,
      placeholder: "Verónica Chumillas",
    },
    {
      name: "Ana del Pino",
      topic: "Negocia con voz propia — alta negociación: estrategia, seguridad y acuerdos de valor.",
      image: bySlot["speaker-ana"] || IMAGES.speakerAna,
      placeholder: "Ana del Pino",
    },
  ];

  return (
    <section
      id="ponentes"
      data-testid="speakers-section"
      className="bg-[#FAF8F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-8 md:gap-14 items-end mb-14 md:mb-20">
          <div className="col-span-12 lg:col-span-7">
            <Reveal>
              <Chapter number="06" label="Ponentes" />
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#3F403A]">
                Voces
                <span className="italic text-[#63846F]"> confirmadas.</span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <Reveal delay={140}>
              <p className="font-sans text-base md:text-lg leading-relaxed text-[#3F403A]/80">
                Cinco perfiles con una mirada práctica, estratégica y
                profundamente conectada con los retos reales de las mujeres que
                lideran negocios, equipos y proyectos en crecimiento.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-8 lg:gap-6 xl:gap-8">
          {speakers.map((s, i) => (
            <Reveal
              key={s.name}
              delay={i * 140}
              className="group"
              data-testid={`speaker-${i}`}
            >
              <div className="relative">
                <PhotoFrame
                  src={s.image}
                  alt={s.name}
                  ratio="3/4"
                  label={s.placeholder}
                  testId={`speaker-photo-${i}`}
                />
                {s.online && (
                  <span
                    className="absolute top-3 right-3 z-10 inline-flex items-center gap-1.5 bg-[#B77A4B] text-[#FAF8F3] overline text-[10px] md:text-[11px] px-2.5 py-1 shadow-[0_4px_12px_-4px_rgba(63,64,58,0.35)]"
                    data-testid={`speaker-online-badge-${i}`}
                  >
                    <span
                      aria-hidden
                      className="inline-block h-1.5 w-1.5 rounded-full bg-[#FAF8F3]"
                    />
                    En línea
                  </span>
                )}
              </div>
              <div className="mt-6 md:mt-8 flex items-start gap-6">
                <div className="pt-2 shrink-0 text-[#63846F] font-serif italic text-xl">
                  0{i + 1}
                </div>
                <div>
                  <h3 className="font-serif text-3xl md:text-4xl text-[#3F403A] leading-tight">
                    {s.name}
                  </h3>
                  <p className="mt-3 font-sans italic text-[#3F403A]/75 text-base md:text-lg leading-relaxed">
                    {s.topic}
                  </p>
                  {s.online && (
                    <p
                      className="mt-2 overline text-[10px] text-[#B77A4B]"
                      data-testid={`speaker-online-note-${i}`}
                    >
                      Intervención en modalidad online
                    </p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Speakers;
